export default "__VITE_PUBLIC_ASSET__604a1592__"